module.exports = __webpack_public_path__ + "img/border_angle_braces.9c2d0332.svg";